import React from 'react';

import { twMerge } from 'tailwind-merge';

import dayjs from 'dayjs';

import NavigationBar from 'components-new/navigation-bar/navigation-bar';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';
import { useOrganisationContext } from 'state/context/OrganisationContext';

import getNewNavigationBarLinks, {
  getAccountMenuItems,
  getAccountMenuViews,
} from 'utils/get-new-navigation-bar-links';

import Message from 'pages/freelancer/FreelancerAvailableJobs/components/message/message';

import Header from './components/header';
import PlannerKanban from './components/planner-kanban';
import PlannerTable from './components/planner-table';
import SidebarFilter from './components/sidebar-filter';

const message = `Binnenkort is het mogelijk om een keuzeopdracht (voorheen bekend als interessediensten) te plaatsen.
            Een keuzeopdracht moet minstens 72 uur voor de dienst geplaatst worden. Een freelancer krijgt uiterlijk 48 uur voor de
            dienst te horen of de opdracht doorgaat. Als de opdracht niet meer nodig is, wordt deze ook 48 uur van tevoren geannuleerd.`;

const title = 'Beste opdrachtgever,';
const delay = '2023-09-15';
const today = dayjs().format('YYYY-MM-DD');
const displayMessage = !!(today < delay);

const OrganizationWeekPlannerPage: React.FC = () => {
  const { gridParams, organizationPlannerSearchParams, tableParams } =
    useOrganizationWeekPlanner();

  const {
    user: { data: userData },
  } = useOrganisationContext();

  const accountMenuItems = getAccountMenuItems(
    userData?.is_freelancer || false,
  );

  const accountMenuViews = getAccountMenuViews(
    userData?.is_freelancer || false,
    userData?.is_organisation_admin || false,
    userData?.is_staff || false,
    'organisation',
  );

  const { viewType } = organizationPlannerSearchParams;

  const links = getNewNavigationBarLinks('assignments');

  return (
    <div
      className={twMerge(
        'grid grid-cols-1 xl:grid-cols-[240px_auto] h-screen grid-rows-[auto_100vh]',
        (gridParams.isLoading || tableParams.isLoading) &&
          'pointer-events-none cursor-wait',
      )}
    >
      <NavigationBar
        className="col-span-2 w-full"
        user={userData}
        links={links}
        accountMenuItems={accountMenuItems}
        accountMenuViews={accountMenuViews}
      />
      <SidebarFilter />
      <div className={twMerge('w-full px-5 lg:px-16 py-9 lg:inline-table')}>
        <Message
          text={message}
          title={title}
          visible={displayMessage}
          variant="warning"
        />
        <Header />

        {viewType === 'grid' && <PlannerKanban />}
        {viewType === 'table' && <PlannerTable />}
      </div>
    </div>
  );
};

export default OrganizationWeekPlannerPage;
